import React, { Component } from "react";

import './LayersButton.css'

import layersIcon from './.image/layer-group-solid@3x.png'

export class LayersButton extends Component {
    render() {
        return (
            <div className="layersButton" onClick={this.props.onClick}>
                <img width='30px' height='30px' src={layersIcon } alt="圖資庫_圖示"/>
                <span>圖資庫</span>
            </div>
        );
    }
}
    